/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type PowerConsumptionControllerV1GetPowerConsumptionStatusItem =
  (typeof PowerConsumptionControllerV1GetPowerConsumptionStatusItem)[keyof typeof PowerConsumptionControllerV1GetPowerConsumptionStatusItem];

export const PowerConsumptionControllerV1GetPowerConsumptionStatusItem = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
  UNPLUGGED: 'unplugged',
} as const;
